import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { ACADEMIC_DATA } from './academics.data';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { ALUMNI_BRIEF_DATA } from '../alumni/alumni.model';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';

@AutoUnsubscribe()
@Component({
  selector: 'app-academics',
  standalone: true,
  imports: [TranslateModule, RouterOutlet],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './academics.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcademicsComponent extends BaseComponent {
  public ACADEMIC_DATA = ACADEMIC_DATA;
  public ALUMNI_DATA = ALUMNI_BRIEF_DATA;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
  }
}
